import ProgressionCheckbox from "./ProgressionCheckbox";

const LoadToggle = ({ handleLoadSwitch, percent, units }) => {
  return (
    <div className="load-toggle">
      <button
        data-button-type={percent ? "outline" : "text-white"}
        onClick={(e) => {
          e.preventDefault();
          if (!percent) handleLoadSwitch(e);
        }}
      >
        %
      </button>
      <button
        data-button-type={!percent ? "outline" : "text-white"}
        onClick={(e) => {
          e.preventDefault();
          if (percent) handleLoadSwitch(e);
        }}
      >
        {units}
      </button>
    </div>
  );
};

const LoadProgression = ({
  handleCheck,
  handleLoadSwitch,
  loadSwitch,
  checked,
}) => {
  const { percent, units } = loadSwitch;

  return (
    <div className="load-progression">
      <ProgressionCheckbox
        checked={checked}
        name="loadProgression"
        onChange={handleCheck}
      >
        Add progressions to Load
      </ProgressionCheckbox>
      <LoadToggle
        handleLoadSwitch={handleLoadSwitch}
        percent={percent}
        units={units}
      />
    </div>
  );
};

export default LoadProgression;
